import { z } from 'zod';

/**
 * Motorcycle engine number validation schema
 * - Must be at least 5 characters (sanity check against typos — no industry standard length exists)
 * - Automatically trims whitespace and converts to uppercase
 */
const motorcycleEngineNumberSchema = z
    .string()
    .trim()
    .min(5, 'Motorcycle engine number must be at least 5 characters')
    .transform((val) => val.toUpperCase());
/**
 * Assign Motorcycle Engine Number form schema for react-hook-form with zodResolver
 * Use with: resolver: zodResolver(assignMotorcycleEngineNumberFormSchema)
 */
const assignMotorcycleEngineNumberFormSchema = z.object({
    motorcycleEngineNumber: motorcycleEngineNumberSchema,
});

export { assignMotorcycleEngineNumberFormSchema, motorcycleEngineNumberSchema };
//# sourceMappingURL=engineNumberValidation.js.map
